'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ReactScrolla = function (_Component) {
  _inherits(ReactScrolla, _Component);

  function ReactScrolla(props) {
    _classCallCheck(this, ReactScrolla);

    var _this = _possibleConstructorReturn(this, (ReactScrolla.__proto__ || Object.getPrototypeOf(ReactScrolla)).call(this, props));

    _this.state = {};
    _this.handleScroll = _this.handleScroll.bind(_this);
    return _this;
  }

  _createClass(ReactScrolla, [{
    key: 'handleScroll',
    value: function handleScroll() {
      var _props = this.props,
          isLoading = _props.isLoading,
          percentage = _props.percentage,
          onPercentage = _props.onPercentage;


      if (isLoading) return;

      var _container = this.container,
          scrollTop = _container.scrollTop,
          scrollHeight = _container.scrollHeight,
          clientHeight = _container.clientHeight;


      if (percentage && onPercentage) {
        var percentNow = scrollTop / (scrollHeight - clientHeight) * 100;

        if (percentNow > percentage) {
          onPercentage();
        }
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var copyProps = _extends({}, this.props);
      delete copyProps.isLoading;
      delete copyProps.percentage;
      delete copyProps.onPercentage;
      delete copyProps.children;

      return _react2.default.createElement(
        'div',
        _extends({
          onScroll: this.handleScroll,
          ref: function ref(container) {
            _this2.container = container;
          }
        }, copyProps),
        this.props.children
      );
    }
  }]);

  return ReactScrolla;
}(_react.Component);

ReactScrolla.propTypes = {
  isLoading: _propTypes2.default.bool,
  percentage: _propTypes2.default.number,
  onPercentage: _propTypes2.default.func,
  children: _propTypes2.default.node
};
ReactScrolla.defaultProps = {
  isLoading: false,
  percentage: 90
};
exports.default = ReactScrolla;
module.exports = exports['default'];